import { logger } from '@/utils/logger/logger';

const TEMP_USER_ID_KEY = 'temp_user_id';
export const LAST_MIGRATED_CHAT_ID_KEY = 'last_migrated_chat_id';

/** Max user messages allowed per chat before an anonymous user must sign up. */
export const MAX_ANONYMOUS_MESSAGES_PER_CHAT = 3;

/**
 * Get temporary user ID from localStorage
 */
export const getTempUserId = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return localStorage.getItem(TEMP_USER_ID_KEY);
  } catch (error) {
    logger.error('Failed to get temp_user_id from localStorage', { error });
    return null;
  }
};

/**
 * Set temporary user ID in localStorage
 */
export const setTempUserId = (tempUserId: string | null): void => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    if (tempUserId) {
      localStorage.setItem(TEMP_USER_ID_KEY, tempUserId);
    } else {
      localStorage.removeItem(TEMP_USER_ID_KEY);
    }
  } catch (error) {
    logger.error('Failed to set temp_user_id in localStorage', { error });
  }
};
